export const lastSearchesSyncKey = 'lastSearchesLastUpdate';
